import { Switch, makeUclComponent } from '@rbilabs/universal-components';

import Link from 'components/link';
import { primitive } from 'styles/constants';

export const ToggleButton = Switch.withConfig({
  offTrackColor: primitive.$blackOpacity50,
  onTrackColor: primitive.$crunchyGreen,
});

export const StyledOptInLink = makeUclComponent(Link).withConfig({
  isInline: true,
  isUnderlined: true,
});
